<template>
	<el-drawer :title="cardTitle" :visible.sync="visible" @close='comStateClose' size="30%" :close-on-press-escape="false"
		id="comDrawer">
		<div class="drawerView">
			<div class="drawerViewT">
				<div class="drawerItem">
					<div class="drawerItemL">分类</div>
					<el-radio-group v-model="cardType">
						<el-radio label="1">现金卡</el-radio>
						<el-radio label="2">活体卡</el-radio>
					</el-radio-group>
				</div>
				<div class="drawerItem">
					<div class="drawerItemL">名称</div>
					<el-input v-model="name" placeholder="请输入礼品卡模板名称" size="small" style="width: 160px;"></el-input>
				</div>
				<div class="drawerItem">
					<div class="drawerItemL">面额</div>
					<el-input-number v-model="cardMoney" :min="0" size="small" style="width: 160px;"></el-input-number>
				</div>
				<div class="drawerItem" v-if="navType == 2">
					<div class="drawerItemL">状态</div>
					<el-radio-group v-model="status">
						<el-radio :label="1">启用</el-radio>
						<el-radio :label="0">禁用</el-radio>
					</el-radio-group>
				</div>
			</div>
			<div class="drawerViewB">
				<div class="btn2" @click="comStateClose">取消</div>
				<div class="btn" @click="handleSubmitClick">保存</div>
			</div>
		</div>

	</el-drawer>
</template>

<script>
	export default {
		props: {
			comState: { //显示状态
				default: false
			},
			navType :{
				default: 0
			},
			navData: {
				default () {
					return {}
				}
			},
		},
		data() {
			return {
				visible: true,
				cardTitle:'',
				cardMoney:0,
				name:'',
				cardType:'1',
				status:1
			}
		},
		mounted() {
			console.log('编辑',this.navData)
			if(this.navType == 1){
				this.cardTitle = '新建礼品卡模板'
			}else if(this.navType == 2){
				this.cardTitle = '编辑礼品卡模板'
				this.name = this.navData.name;
				this.cardMoney = this.navData.cardMoney;
				this.cardType = this.navData.cardType.value;
				this.status = this.navData.status;
			}
		},
		methods: {
			
			//保存
			handleSubmitClick() {
				if(this.name == ''){
					this.$message({
						type: 'error',
						message: '请输入名称'
					})
					return
				}
				if(this.cardMoney == 0){
					this.$message({
						type: 'error',
						message: '请输入面额'
					})
					return
				}
				console.log(this.navData)
				let params = {
					name:this.name,
					cardType:this.cardType,
					cardMoney:this.cardMoney,
					status:this.status
				};
				if(this.navType == 1){
					params.id = ''
				}else if(this.navType == 2){
					params.id = this.navData.id
				}
				this.$http.post(process.env.VUE_APP_Url2 + 'api/product/giftCard/template/update', params).then(
					res => {
						if (res.code == 0) {
							if(this.navType == 1){
								this.$message({
									type: 'success',
									message: '已新建'
								})
							}else if(this.navType == 2){
								this.$message({
									type: 'success',
									message: '已变更'
								})
							}
							this.$emit("closeOn", {
								type: 'submit'
							});
						}
					})

			},
			//向父组件发射关闭弹框
			comStateClose() {
				this.$emit("closeOn", {
					type: 'close'
				});
			},
		},
		watch: {
			// 监视状态发生改变
			comState() {
				this.visible = this.comState;
			},
		},
	}
</script>

<style scoped lang="scss">
	#comDrawer {
		::v-deep .el-drawer__header {
			padding: 20px;
			margin-bottom: 0;
		}

		::v-deep .el-drawer__body {
			height: calc(100% - 65px);
			overflow-y: auto;
		}
	}

	.drawerView {
		height: 100%;

		.drawerViewT {
			height: calc(100% - 60px);
			box-sizing: border-box;
			border-top: solid 1px #F2F2F2;
			overflow-y: scroll;
			padding: 0 20px;

			.drawerItem {
				display: flex;
				align-items: center;
				margin-top: 20px;

				.drawerItemL {
					width: 80px;
					font-weight: bold;
					font-size: 14px;
					text-align: right;
					margin-right: 12px;
				}
			}
		}

		.drawerViewT::-webkit-scrollbar {
			display: none;
		}

		.drawerViewB {
			height: 60px;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			padding: 0 20px;
			border-top: solid 1px #F2F2F2;
			box-sizing: border-box;

			.btn {
				width: 98px;
				line-height: 40px;
				text-align: center;
				background: #F58B2F;
				border-radius: 10px;
				font-size: 16px;
				font-weight: bold;
				color: #fff;
				cursor: pointer;
				margin-left: 20px;
			}

			.btn2 {
				width: 98px;
				line-height: 40px;
				text-align: center;
				background: #E3E3E3;
				border-radius: 10px;
				font-size: 16px;
				font-weight: bold;
				color: #666;
				cursor: pointer;
			}
		}
	}
</style>
